import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import "../../src/App.css"
import { Container, Image, Breadcrumb, Card, Col, Row } from "react-bootstrap";



const SiteMap = () => {
    return (
        <>
              <Container className="generalHero  pt-4">
        <div className="d-flex justify-content-start ">
          <Breadcrumb >
            <Breadcrumb.Item href="/"  >Home</Breadcrumb.Item>
            <Breadcrumb.Item active >Sitemap</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </Container>
            <div className='site-continer text-center'>
                <div className='pb-lg-5 pb-sm-0'>
                    <h1 classname ="fw-bold" > Wellcreator <span className='siteheading'> Sitemap </span></h1>
                    <div className='site-line1'></div>
                </div>

                <div class="container-sitemap">
                    <div class="pages-links">
                        <div class="column">
                            <h3 class="last">SERVICES</h3>
                            <div className='site-line'></div>
                            <ul class="links-list">
                                <li><Link to="/website-development" className="custom-link">
                                    Website Development
                                </Link></li>
                                 <li><Link to="/custom-software-development-services" className="custom-link">
                                    Custom Software Development
                                 </Link></li>
                                 <li><Link to="/unity-game-development-company" className="custom-link">
                                    Unity Development
                                </Link></li>
                                <li><Link to="/mobile-development" className="custom-link">Mobile App Development</Link></li>
                                <li><Link to="/affordable-seo-services-uk" className="custom-link">
                                    SEO (Search Engine Optimization)
                                </Link></li>
                                 <li><Link to="/wordpress-development-services" className="custom-link">
                                  Wordpress Development
                                </Link></li>
                                <li><Link to="/shopify" className="custom-link">
                                  Shopify Development
                                </Link></li>
                                <li><Link to="/.Net-development-services" className="custom-link">
                                  .Net Development
                                </Link></li>
                                {/* <li><Link to="/DigitalMarketing" className="custom-link">
                                  Digital Marketing
                                </Link></li> */}
                                <li><a href="#" target="_blank">Project Rescue</a></li>
                                <li><a href="#" target="_blank">App Modernization</a></li>
                                <li><a href="#" target="_blank">IT Consulting</a></li>
                                <li><a href="#" target="_blank">UI/UX Design</a></li>
                                <li><a href="#" target="_blank">DevOps Engeneering</a></li>
                                <li><a href="#" target="_blank">Full-cycle Development for Startups</a></li>
                                <li><a href="#" target="_blank">Discovery Phase</a></li>
                                <li><a href="#" target="_blank">MVP Development</a></li>
                                <li><a href="#" target="_blank">Dedicated Team</a></li>
                            </ul>
                        </div>
                        <div class="column">
                            <h3 class="last">expertise</h3>
                            <div className='site-line'></div>
                            <ul class="links-list">
                                <li><a href="#" target="_blank">HealthTech</a></li>
                                <li><a href="#" target="_blank">Logistics Software Development</a></li>
                                <li><a href="#" target="_blank">eLearning Software Development</a></li>
                                <li><a href="#" target="_blank">Fantasy Sports &amp; Gaming</a></li>
                                <li><a href="#" target="_blank">FinTech</a></li>
                                <li><a href="#" target="_blank">E-Commerce</a></li>
                                <li><a href="#" target="_blank">On-demand Apps</a></li>
                                <li><a href="#" target="_blank">Indoor Navigation</a></li>
                                <li><a href="#" target="_blank">iBeacon App Development</a></li>
                                <li><a href="#" target="_blank">Trading Software Development</a></li>
                                <li><a href="#" target="_blank">AR and VR Apps</a></li>
                                <li><a href="#" target="_blank">Social Networks</a></li>
                            </ul>
                        </div>
                        <div class="column">
                            <div class="links-block">
                                <h3 class="last">Company</h3>
                                <div className='site-line'></div>
                                <ul class="links-list">
                                    <li><Link to="/about-us" className="custom-link">
                                    About Us
                                </Link></li>
                                <li><Link to="/career" className="custom-link">
                                    Career
                                </Link></li>
                                    <li><Link to="/Team" className="custom-link">
                                    Our Team
                                </Link></li>
                                    <li><a href="#" target="_blank">How We Work</a></li>
                                    <li><a href="#" target="_blank">Testimonials &amp; Awards</a></li>
                                </ul>
                            </div>
                            <div class="links-block">
                                <h3 class="last">insights</h3>
                                <div className='site-line'></div>
                                <ul class="links-list">
                                    <li><Link to="/Referral-Program" className="custom-link">
                                  Referral Program
                                </Link></li>
                                <li><Link to="/our-packages" className="custom-link">
                                  Our Package
                                </Link></li>
                                    <li><a href="#" target="_blank">FAQs</a></li>
                                    <li><a href="blog/" target="_blank">Blog</a></li>
                                    <li><a href="#" target="_blank">News</a></li>
                                </ul>
                            </div>
                            <div class="links-block">
                            <h3 class="last">portfolio</h3>
                            <div className='site-line'></div>
                            <ul class="links-list">
                                <li><Link to="/portfolio" className="custom-link">
                                  Portfolio
                                </Link></li>
                            </ul>
                            </div>
                            <div class="links-block">
                            <h3 class="last">contact us</h3>
                            <div className='site-line'></div>
                            <ul class="links-list">
                                <li><Link to="/contact-us" className="custom-link">
                                  Contact Us
                                </Link></li>
                                <li><Link to="/get-a-quote" className="custom-link">
                                  Quotation
                                </Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </>
    );
}

export default SiteMap;